<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-cc-vscroll-table #ccTable [transPartKey]="transPartKey"
                      [tableConfig]="tableConfig"
                      [headerButtonConfig]="headerButtonConfig"
                      [contextMenuConfig]="tableContextMenuConfig"
                      [records]="records"
                      [recordIds]="recordIds"
                      [(selectedIds)]="selectedIds"
                      (selectedIdsChange)="onTableSelectedIdsChange($event)"
                      [(selectionType)]="selectionType"
                      [totalRecords]="totalRecords" [loading]="tableLoadingCount>0"
                      [currentRequest]="tableCurrentRequest"
                      (loadRecordsEvent)="loadRecords($event)"
                      [fieldName]="'id'" [fieldId]="'id'" [scrollHeightNumber]="scrollHeight"
                      [defaultSortField]="tableConfigService.defaultSortField" [defaultSortOrder]="tableConfigService.defaultSortOrder"
                      (onRowDblClick)="rowDblClick($event)"
                      (onCtrlShift)="ctrlShift($event)"
                      (onShift_S)="rowDblClick($event)"
                      (filterChangedEvent)="filterSortChanged()" (sortChangedEvent)="filterSortChanged()"
                      (onColOrderChange)="colOrderChanged($event)">
  <span caption-left-left pButton class="p-button-text p-button-sm header-button"
          [icon]="'fa fa-bars-staggered'"
          (click)="activeChanged()" pTooltip="{{'page.' + transPartKey + '.table.'+
          'show_aggregates' | translate}}"></span>
  <!--  (onContextMenuShow)="refreshContextMenu()"-->
  <button caption-right pButton class="p-button-text p-button-sm header-button" [icon]="'fa fa-table-columns'"
          (click)="selectTableColumns()" pTooltip="{{'common.table.select_visible_columns' | translate}}"
          tooltipPosition="left"></button>
  <button *ngIf="maximizable" caption-right pButton class="p-button-text p-button-sm header-button"
          [icon]="'fa fa-'+(maximized?'compress':'expand')"
          (click)="maximize()" pTooltip="{{'common.'+(maximized?'minimize':'maximize') | translate}}"
          tooltipPosition="left"></button>

  <span
    footer-left>{{('common.lastUpdated'|translate) + ': ' + (lastUpdated ? (lastUpdated|date:'HH:mm:ss') : '')}}</span>

  <app-clearing-selection-summary footer-right [isDark]="true"
                                  [summaryBuyValue]="summaryBuyValue"
                                  [summarySellValue]="summarySellValue"></app-clearing-selection-summary>

  <p-progressSpinner footer-right class="cc-spinner-sm" *ngIf="isSelectionInfoLoading" strokeWidth="5"
                     fill="var(--surface-ground)" animationDuration="0.8s"></p-progressSpinner>

  <button footer-right pButton
          [class]="'footer-button p-button-text p-button-sm selection-info-button ' + (!isSelectionInfoEnabled?'selection-info-disabled':'')
          + (isSelectionInfoClosed?'selection-info-closed':(isSelectionInfoEnabledLock?'selection-info-locked':''))"
          [icon]="'fa fa-scale-balanced'"
          (click)="toggleSelectionInfoEnabled()"
          pTooltip="{{('page.'+transPartKey+'.table.'+(isSelectionInfoClosed?'open_selection_info':
          (isSelectionInfoEnabledLock?'disable_selection_info':(isSelectionInfoEnabled?'lock_selection_info':'enable_selection_info'))
          )) | translate}}"
          tooltipPosition="left"></button>
  <!--  will add the in a next version-->
  <button footer-right pButton
          [class]="'footer-button p-button-text p-button-sm selection-info-button ' + (ctrlAMode=='ALL_IDS'?'selection-info-disabled':'')
          + (ctrlAMode=='ALL_OPTIM'?'':(ctrlAMode=='ALL'?'selection-info-locked':''))"
          [icon]="'fa fa-check-double'"
          (click)="toggleCtrlAllModeEnabled()"
          pTooltip="{{('page.'+transPartKey+'.table.'+(ctrlAMode=='ALL_IDS'?'ctrl_a_all_fix':
          (ctrlAMode=='ALL_OPTIM'?'ctrl_a_all_ids':(ctrlAMode=='ALL'?'ctrl_a_all_optim':''))
          )) | translate}}"
          tooltipPosition="top"></button>
</app-cc-vscroll-table>
<app-trade-selection-table-dialog #tradeSelectionDialog
                                  [selectedTradeIds]="selectedIds"
                                  (applySelectionChange)="filterSelectedIds($event)"
                                  (doSingleAllocate)="singleAllocation($event)"
                                  (doSplitAllocate)="splitAllocation($event)"
                                  (dialogManuallyClosed)="isSelectionInfoClosed=true"
                                  [isReadOnly]="isReadOnly()"
                                  [userView]="userView"
                                  [viewConfig]="viewConfig"
                                  [ctrlAMode]="ctrlAMode"
                                  [selectionType]="selectionType"
                                  [tradeTableCurrentRequest]="tableCurrentRequest"></app-trade-selection-table-dialog>
<!--defaultSortFieldName="creationDate"-->
<app-clearing-trade-detail #tradeDetailDialog></app-clearing-trade-detail>
<app-clearing-single-allocation-form #singleAllocationDialog
                                     (onSavedForm)="onSingleAllocationSubmit($event)"></app-clearing-single-allocation-form>
<app-clearing-single-allocation-multi-exchange-form #singleAllocationMultiExchangeDialog
                                                    (onSavedForm)="onSingleAllocationMultiExchangeSubmit($event)"></app-clearing-single-allocation-multi-exchange-form>
<app-clearing-split-allocation-form #splitAllocationDialog
                                    (onSavedForm)="onSplitAllocationSubmit($event)"></app-clearing-split-allocation-form>
<app-clearing-override-custom-reference-form #overrideCustomReferenceDialog
                                             (onSavedForm)="onUpdateTradePrice($event)"></app-clearing-override-custom-reference-form>
<app-clearing-update-trade-price-form #updateTradePriceDialog
                                             (onSavedForm)="onUpdateTradePrice($event)"></app-clearing-update-trade-price-form>
<app-clearing-select-table-columns-form #selectTableColumnsDialog
                                        (onSavedForm)="onSelectTableColumns($event)"></app-clearing-select-table-columns-form>
<app-clearing-create-order-form #createOrderDialog
                                        (onSavedForm)="onCreateOrder($event)"></app-clearing-create-order-form>
<app-flex-edit-form-dialog *ngIf="appConfigService.flexEnabled" #flexDialogEditForm></app-flex-edit-form-dialog>
<app-flex-batch-edit-form-dialog *ngIf="appConfigService.flexEnabled" #flexDialogBatchEditForm></app-flex-batch-edit-form-dialog>
